"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.abis = void 0;
const Agent_json_1 = __importDefault(require("./Agent.json"));
const ERC20_json_1 = __importDefault(require("./ERC20.json"));
const Hatch_json_1 = __importDefault(require("./Hatch.json"));
const HatchOracle_json_1 = __importDefault(require("./HatchOracle.json"));
const ImpactHours_json_1 = __importDefault(require("./ImpactHours.json"));
const MiniMeToken_json_1 = __importDefault(require("./MiniMeToken.json"));
const utils_1 = require("../utils");
exports.abis = new Map([
    [utils_1.HATCH_APP, Hatch_json_1.default],
    [utils_1.HATCH_ORACLE_APP, HatchOracle_json_1.default],
    [utils_1.IMPACT_HOURS_APP, ImpactHours_json_1.default],
    [utils_1.AGENT_APP, Agent_json_1.default],
    [utils_1.ERC20_TOKEN, ERC20_json_1.default],
    [utils_1.MINIME_TOKEN, MiniMeToken_json_1.default],
]);
//# sourceMappingURL=index.js.map